import clsx from 'clsx';

const placeholderClassName =
  'animate-shimmer motion-reduce:animate-none bg-[length:200%_100%] bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100';

export default function DuctedSystemSkeletonCard() {
  return (
    <div
      data-testid='ducted-representative-skeleton'
      aria-hidden
      className='flex h-full w-full flex-col rounded-lg border border-gray-200 bg-white p-4 shadow-sm'
    >
      <div className='flex items-start justify-between gap-3'>
        <div className={clsx(placeholderClassName, 'h-5 w-2/5 rounded')} />
        <div
          className={clsx(placeholderClassName, 'h-5 w-16 shrink-0 rounded')}
        />
      </div>
      <div className='mt-3 flex flex-col gap-2'>
        <div className={clsx(placeholderClassName, 'h-3 w-3/4 rounded')} />
        <div className={clsx(placeholderClassName, 'h-3 w-1/2 rounded')} />
      </div>
      <div className='mt-3 flex gap-2'>
        <div
          className={clsx(placeholderClassName, 'h-16 w-16 shrink-0 rounded')}
        />
        <div
          className={clsx(placeholderClassName, 'h-16 w-16 shrink-0 rounded')}
        />
        <div
          className={clsx(placeholderClassName, 'h-16 w-16 shrink-0 rounded')}
        />
      </div>
      <div className='mt-3 grid grid-cols-2 gap-2'>
        <div
          className={clsx(
            placeholderClassName,
            'h-[4.5rem] rounded-lg border border-gray-100'
          )}
        />
        <div
          className={clsx(
            placeholderClassName,
            'h-[4.5rem] rounded-lg border border-gray-100'
          )}
        />
      </div>
      <div className='mt-3 flex items-center justify-between border-t border-gray-100 pt-2'>
        <div className={clsx(placeholderClassName, 'h-5 w-28 rounded')} />
        <div className={clsx(placeholderClassName, 'h-8 w-24 rounded-md')} />
      </div>
    </div>
  );
}
